


































































































































































import { Component, Mixins } from "vue-property-decorator";
import { mapState } from "vuex";

// Mixins
import { FilteringSortingTableStore } from "@/mixins/tableWithFilteringAndSortingStore";
import AdminBrandId from "@/mixins/adminBrandId";

// Enums/Data
import { DataModules } from "@/store/modules/data";
import { ConfirmModalModes } from "@/data/enums";
import ticketDepartmentsFilters from "@/data/filters/tickets";
import ticketDepartmentsSorters from "@/data/sorters/tickets";
import { IState } from "@/store";
import { IBrand } from "@/models/brands";
import { ITicketDepartment } from "@/models/tickets";

// Typings
@Component({
  computed: {
    ...mapState({
      brand(state: IState) {
        return state.brand;
      }
    })
  }
})
export default class TicketDepartmentsTable extends Mixins(
  FilteringSortingTableStore,
  AdminBrandId
) {
  // Getters
  public brand!: IBrand;

  public filters = ticketDepartmentsFilters;
  public sorters = ticketDepartmentsSorters;

  public dataModule: DataModules = DataModules.TICKETS_DEPARTMENTS;

  public async created() {
    if (!this.contentAvailable) {
      return;
    }
    this.getData();
  }

  public async confirmDelete(rule) {
    if (!this.canDelete()) return;
    const modal = await this.$store.dispatch("ui/open/confirmModal", {
      config: {
        parent: this,
        props: {
          mode: ConfirmModalModes.BUTTON,
          autoClose: false,
          confirmButtonText: this.$t("_action.delete"),
          message: this.$t("_sentence.delete_confirmation", {
            object: (this.$tc(
              "_.ticket_departments",
              1
            ) as string).toLowerCase()
          })
        },
        canCancel: [],
        events: {
          confirmed: async () => {
            try {
              await this.delete(rule);
              await this.getData({ ignoreStored: true });

              this.$buefy.toast.open({
                message: this.$t("_.object_successfully_removed", {
                  object: this.$tc("_.ticket_departments", 1)
                }) as string
              });
              modal.close();
            } catch (error) {
              modal.close();
              this.$store.dispatch("api/handleError", error);
            }
          }
        }
      }
    });
  }

  public delete(department) {
    return this.$store.dispatch(
      `data/${DataModules.TICKETS_DEPARTMENTS}/remove`,
      {
        id: department.id
      }
    );
  }

  public async makeDefault(departmentId: ITicketDepartment["id"]) {
    this.table.loading = true;
    try {
      await this.$store.dispatch(
        `data/${DataModules.TICKETS_DEPARTMENTS}/update`,
        {
          data: {
            default: true
          },
          id: departmentId
        }
      );
      this.$store.dispatch("toast/show", {
        message: this.$t("_sentence.ticket.default_department_changed")
      });
      await this.getData({ ignoreStored: true });
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    } finally {
      this.table.loading = false;
    }
  }

  public update(department) {
    if (!this.canUpdate()) return;

    this.$store.dispatch(`data/${this.dataModule}/openAddEditModal`, {
      props: {
        department
      },
      events: {
        success: () => {
          this.getData({ ignoreStored: true });
        }
      }
    });
  }

  public canUpdate() {
    return this.$userCan("update_tickets_departments");
  }

  public canDelete() {
    return this.$userCan("delete_tickets_departments");
  }

  public get contentAvailable() {
    return this.$userCan("list_tickets_departments");
  }
}
